import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import MedicalHistoryTab from '@pages/donor-detail/ui/MedicalHistoryTab'

function MedicalHistoryRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <MedicalHistoryTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/medical-history',
)({
  component: MedicalHistoryRoute,
})
